import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Section } from '../Styled';

export const KortSection = styled(Section)`
@media screen and (max-width: 640px) {
  padding: 100px 0;
}
`

export const ServiceKortCon = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 25px;
  row-gap: 25px;
  column-gap: 25px;
  @media screen and (max-width: 640px) {
    padding: 25px 0;
    justify-content: center;
  }
`;

export const KortLink = styled(Link)`
text-decoration: none;
`

export const ServiceKort = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 30%;
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 0;
  box-shadow: 0 20px 30px 0 rgb(0 0 29 / 15%);
  border-radius: 20px;
  height: max-content;
  padding: 50px 25px;
  @media screen and (max-width: 900px) and (min-width: 640px) {
    flex-direction: row;
    justify-content: space-around;
    flex-basis: 100%;
  }
  @media screen and (max-width: 640px) {
    flex-basis: 95%;
    align-items: center;
  }
`;

export const PrplServiceKort = styled(ServiceKort)`
  background-color: ${({ theme }) => theme.mainColors.prpl};
`;
export const BluServiceKort = styled(ServiceKort)`
  background-color: ${({ theme }) => theme.mainColors.lightblu};
`;
export const RedServiceKort = styled(ServiceKort)`
  background-color: ${({ theme }) => theme.mainColors.darkprpl};
`;

export const KortTitel = styled.h2`
  text-align: center;
  color: ${({ theme }) => theme.mainColors.hvid};
  font-size: 28px;
  font-weight: bold;
  line-spacing: 1.4;
  margin: 0;
  @media screen and (max-width: 900px) and (min-width: 650px) {
    text-align: left;
  }
`;

export const KortUnderTitel = styled.h3`
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.mainColors.hvid};
  text-align: center;
  margin: 0;
  @media screen and (max-width: 900px) and (min-width: 650px) {
    text-align: left;
  }
`;

export const Mockup = styled.img`
  display: block;
  object-fit: contain;
  height: 300px;
  max-width: 300px;
`;
